import { render, staticRenderFns } from "./AppointmentsFormModal.vue?vue&type=template&id=6a238854&"
import script from "./AppointmentsFormModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsFormModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports